import type { Filter, SearchToken, Source } from '../types';

export const tokenizeSearchString = (searchString: string) => {
  if (!searchString) return [];

  const searchTokens: SearchToken[] = [];
  const rawTokens = searchString.split(/\s+/).filter(Boolean);

  for (const rawToken of rawTokens) {
    if (rawToken.startsWith('in:')) {
      searchTokens.push({
        type: 'source',
        value: rawToken.slice(3) as Source
      });

      continue;
    }

    if (rawToken.startsWith('filter:')) {
      searchTokens.push({
        type: 'filter',
        value: rawToken.slice(7) as Filter
      });

      continue;
    }

    if (rawToken.startsWith('tag:')) {
      searchTokens.push({
        type: 'tag',
        fullName: rawToken.slice(4)
      });

      continue;
    }

    searchTokens.push({ type: 'text', value: rawToken });
  }

  return searchTokens;
};
